import { CollaborativeUser } from 'app/components/Song/Lyrics/TextEditor/types';

export const createCursorElement = (user: Record<string, any>) => {
  const root = document.createElement('span');
  root.classList.add('caret-root');
  root.setAttribute(
    'style',
    `--user-color: ${user.profile?.avatarColors?.text}`
  );

  const cursor = document.createElement('span');
  cursor.classList.add('caret');

  const label = document.createElement('div');
  label.setAttribute('clientId', user.clientId);
  label.classList.add('caret-label');
  label.insertBefore(document.createTextNode(user.name), null);
  cursor.insertBefore(label, null);

  root.appendChild(cursor);

  return root;
};

export const addIsSelfProperty = (
  users: CollaborativeUser[],
  clientId: number
) =>
  users.map((user) =>
    user.clientId === clientId ? { ...user, isSelf: true } : user
  );

export const getEditorProps = ({ isEditable }: { isEditable: boolean }) => {
  if (isEditable) {
    return {};
  }

  return {
    onKeyDown: (e) => {
      e.preventDefault();
    },
    onPasteCapture: (e) => {
      e.preventDefault();
    },
    onDragStart: (e) => {
      e.preventDefault();
    },
    onDropCapture: (e) => {
      e.preventDefault();
    },
  };
};
